import { Reducer } from 'redux';
import { IApiRequest, IStoreDocument } from '../../types/index';
import {
  GET_RETAILER_STORE_DOCUMENTS_ERROR,
  GET_RETAILER_STORE_DOCUMENTS_REQUEST,
  GET_RETAILER_STORE_DOCUMENTS_RESPONSE,
} from '../../actions/StoreDocuments/getRetailerStoreDocumentsAction';

const initialState: IApiRequest<IStoreDocument[]> = {
  data: undefined,
  error: '',
  UpdatedAt: null,
  loading: false,
};

const retailerStoreDocumentsReducer: Reducer<IApiRequest<IStoreDocument[]>>
  = (state: IApiRequest<IStoreDocument[]> = initialState, action: any) => {
    switch (action.type) {
      case GET_RETAILER_STORE_DOCUMENTS_RESPONSE: {
        return {
          data: action.response,
          error: '',
          UpdatedAt: new Date(),
          loading: false,
        };
      }
      case GET_RETAILER_STORE_DOCUMENTS_REQUEST: {
        return {
          data: undefined,
          error: '',
          UpdatedAt: null,
          loading: true,
        };
      }
      case GET_RETAILER_STORE_DOCUMENTS_ERROR: {
        return {
          data: undefined,
          error: 'An error has occured',
          UpdatedAt: null,
          loading: false,
        };
      }
      default: {
        return state;
      }
    }
  };

export default retailerStoreDocumentsReducer;
